import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
`

const LeftSide = styled.div`
  flex: 0 0 50%;
  background-image: url('/images/Split-image.jpg');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  min-height: 100vh;
  overflow: hidden;
  border-top-right-radius: 60px;
  border-bottom-right-radius: 60px;
`

const RightSide = styled.div`
  flex: 0 0 50%;
  background-color: #ffffff;
  display: grid;
  grid-template-rows: max-content 1fr max-content;
  min-height: 100vh;
  position: relative;
  overflow-y: auto;
`

const BrandHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 32px;

  img {
    height: 64px;
    width: auto;
  }
`

const FormSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 10%;
  margin: 0;
  width: 100%;
`

const FormTitle = styled.h1`
  font-size: 52px;
  font-weight: 700;
  color: #000000;
  line-height: 1.2;
`

const FormSubtitle = styled.h2`
  font-size: 24px;
  color: #707D8D;
  line-height: 1.5;
  font-weight: 400;
`

const FormContainer = styled.div`
  width: 100%;
`

const Wrap = styled.section`
  display: flex;
  padding: 20px 0;
  width: 100%;
  flex-direction: column;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
`

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  > * {
    flex: 50%;
  }
`

const InputGroup = styled.div`
  margin-bottom: 24px;
  position: relative;
`

const InputLabel = styled.label`
  position: absolute;
  top: 8px;
  left: 16px;
  font-size: 12px;
  color: #6b7280;
  font-weight: 400;
  pointer-events: none;
  transition: all 0.2s ease;
`

const InputField = styled.input`
  width: 100%;
  height: 48px;
  padding: 30px 16px 12px;
  font-size: 16px;
  color: #000000;
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  outline: none;
  transition: border-color 0.2s ease;

  &:focus {
    border-bottom-color: #0057b8;
  }

  &:focus + ${InputLabel} {
    color: #6b7280;
  }

  &::placeholder {
    color: #9ca3af;
  }

  &.has-error {
    border-color: #dc2626;
  }
`

const PrimaryButton = styled.button`
  width: 100%;
  height: 48px;
  background-color: #000000;
  border-radius: 8px;
  color: #ffffff;
  border: none;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 0.2s ease;
  letter-spacing: 0.5px;
  margin-top: 24px;

  &:hover {
    background-color: #1f2937;
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
  }
`

const HelpSection = styled.div`
  margin-top: 24px;
  text-align: center;
`

const HelpText = styled.p`
  font-size: 14px;
  color: #006dff;
  line-height: 1.6;
  text-align: center;

  a {
    color: #006dff;
    text-decoration: underline;
    
    &:hover {
      color: #003d82;
    }
  }
`

const FooterSection = styled.div`
  padding: 24px 40px;
  text-align: center;
  border-top: 1px solid #f3f4f6;
`

const FooterText = styled.p`
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
`

const ErrorContainer = styled.div`
  margin: 10px 0;
`

const ErrorMessage = styled.p`
  color: #dc2626;
  font-size: 14px;
  margin-top: 8px;
  line-height: 1.4;
  display: flex;
  align-items: center;
  gap: 6px;

  &::before {
    content: "✕";
    font-size: 16px;
    font-weight: bold;
    flex-shrink: 0;
  }
`

const TextLink = styled.a`
  color: #006dff;
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #003d82;
  }
`

const PasswordWrapper = styled.div`
  position: relative;
  width: 100%;
`

const PasswordToggle = styled.button`
  position: absolute;
  text-decoration:underline;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #1e1e1eff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 8px;
`

const PasswordValidationList = styled.div`
  margin-top: 16px;
  padding-bottom: 16px;
  border-radius: 4px;
`

const ValidationTitle = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 12px;
  font-weight: 500;
`

const ValidationItem = styled.div<{ met: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  color: ${props => props.met ? '#10b981' : '#ef4444'};

  &:last-child {
    margin-bottom: 0;
  }
`

const ValidationIcon = styled.span<{ met: boolean }>`
  font-size: 16px;
  font-weight: bold;
  flex-shrink: 0;
`

export {
  Wrapper,
  LeftSide,
  RightSide,
  BrandHeader,
  FormSection,
  FormTitle,
  FormSubtitle,
  FormContainer,
  Wrap,
  Column,
  Row,
  InputGroup,
  InputLabel,
  InputField,
  PrimaryButton,
  HelpSection,
  HelpText,
  FooterSection,
  FooterText,
  ErrorContainer,
  ErrorMessage,
  TextLink,
  PasswordWrapper,
  PasswordToggle,
  PasswordValidationList,
  ValidationTitle,
  ValidationItem,
  ValidationIcon,
}

